var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19ZM18.9866 19.305C21.7884 19.305 24.0659 17.1063 24.0659 14.4033C24.0659 11.6993 21.7884 9.5 18.9866 9.5C16.1855 9.5 13.9074 11.6993 13.9074 14.4033C13.9074 17.1063 16.1855 19.305 18.9866 19.305ZM24.0046 22.128C23.0862 22.6848 22.089 23.0796 21.0551 23.307L23.8946 26.0482C24.4763 26.6085 24.4763 27.5185 23.8946 28.0794C23.3135 28.6403 22.3717 28.6403 21.7912 28.0794L18.9995 25.3857L16.2102 28.0794C15.9193 28.3596 15.5382 28.4998 15.1571 28.4998C14.7766 28.4998 14.3961 28.3596 14.1053 28.0794C13.5242 27.5185 13.5242 26.6091 14.1047 26.0482L16.9444 23.307C15.9105 23.0796 14.9134 22.6842 13.995 22.128C13.2999 21.7049 13.0911 20.8187 13.5291 20.1472C13.9658 19.4748 14.8842 19.2724 15.5805 19.6954C17.6598 20.958 20.3385 20.9583 22.4191 19.6954C23.1154 19.2724 24.0335 19.4748 24.4711 20.1472C24.909 20.8181 24.6996 21.7049 24.0046 22.128Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9866 12.3735C20.1463 12.3735 21.0897 13.2838 21.0897 14.4033C21.0897 15.5219 20.1463 16.4328 18.9866 16.4328C17.8278 16.4328 16.8835 15.5219 16.8835 14.4033C16.8835 13.2838 17.8278 12.3735 18.9866 12.3735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.48239c4ebb4cb52635719355836405d4.svg";
export { ForwardRef as ReactComponent };